import styled, { css } from 'styled-components';

export const LoaderContainer = styled.div`
  box-shadow: 0px 2px 8px 0px rgba(11, 18, 30, 0.08);
  min-width: 285px;
  height: 300px;
  border-radius: 16px;
  background: ${({ theme }) => theme.communityList.cardBackground};
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: ${({ content }) => content ?? 'start'};
  align-items: baseline;
  padding-left: 10px;
  padding-right: 10px;
  gap: 10px;
`;

export const DetailsContainer = styled.div`
  width: ${({ width }) => width}%;
  height: ${({ height }) => height}px;
  border-radius: 15px;
  margin-top: 15px;
  background: ${({ theme }) => theme.communityList.cardBackground};
  background: linear-gradient(
    110deg,
    ${({ theme }) => theme.communityList.borderColor} 5%,
    ${({ theme }) => theme.communityList.loaderColor} 25%,
    ${({ theme }) => theme.communityList.borderColor} 50%
  );
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }

  ${({ isImage }) =>
    isImage &&
    css`
      margin-top: 0px;
      border-radius: 16px 16px 0 0;
    `};
`;
